import axios from 'axios'

const API_PATH = 'api/v2/admins/stock_opnames'

const StockOpnamesApiV2 = {
  get: async ({ q = '', scope = 'in_progress', internal_category_filter = '', target_date = '', page = 1, per_page = 20 } = {}) => {
    const params = {
      scope: scope || 'in_progress',
      page,
      per_page
    }

    const normalizedQuery = q.toString().trim()
    if (normalizedQuery) params.q = normalizedQuery
    if (internal_category_filter) params.internal_category_filter = internal_category_filter
    if (target_date) params.target_date = target_date

    return axios.get(API_PATH, { params })
  },

  show: async (id) => {
    return axios.get(`${API_PATH}/${id}`)
  },

  create: async (values) => {
    return axios.post(API_PATH, {
      stock_opname: values
    })
  },

  update: async ({ id, values }) => {
    return axios.patch(`${API_PATH}/${id}`, {
      stock_opname: values
    })
  },

  bulkAddEntries: async ({ id, skuList }) => {
    return axios.post(`${API_PATH}/${id}/bulk_add_entries`, {
      sku_list: skuList
    })
  },

  generateEntries: async (id) => {
    return axios.post(`${API_PATH}/${id}/generate_entries`)
  },

  downloadExcel: async (id) => {
    return axios.get(`${API_PATH}/${id}/download_excel`, { responseType: 'blob' })
  }
}

export default StockOpnamesApiV2
